import React from "react";
import AddNoteButton from "../Buttons/AddNoteButton";

function TopTitleNoteContainer(props) {
  return (
    <div className="notes-button-container" style={{ marginBottom: "10px" }}>
      <AddNoteButton title={props.title} handleOpen={props.handleOpen} />

      {/* <ButtonSortByDate /> */}
    </div>
  );
}

export default TopTitleNoteContainer;
